<template>
	<Modal @dismiss="$emit('dismiss')" :custom_style="{ width: '480px', 'max-height': '640px' }">
		<div id="closeButtonWrapper">
			<button class="button-icon light button-close" type="button" @click="$emit('dismiss')">
				<img src="../../assets/img/icons/round-close-24px.svg" />
			</button>
		</div>
		<div id="connectFormWrapper">
			<h4>Connect a TV screen</h4>
			<p>Follow the steps below to get your Gleebeam dashboard displayed on an external screen without signing in.</p>
			<h5 class="mt-32">Step 1</h5>
			<p>
				Open
				<b>https://gleebeam.com/tv</b> in the browser on your TV screen.
			</p>
			<h5 class="mt-32">Step 2</h5>
			<p>Enter the 6-character passcode that appears on the screen.</p>
			<input :value="passcode_uppercase" @input="passcode = $event.target.value" type="text" class="mt-8" placeholder="Enter the passcode here" />
			<div id="buttonContainer" class="mt-32">
				<!-- <button type="button" class="button secondary mr-8" @click="$emit('dismiss')">Cancel</button> -->
				<button v-if="loading" class="button primary loading" type="button">
					<Spinner />
				</button>
				<button
					v-else
					type="button"
					class="button primary"
					@click="submitPasscode"
					:disabled="passcode.length !== 6"
				>Connect</button>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from "./modal";
import Spinner from "../loading/spinner";

export default {
	data() {
		return {
			passcode: "",
			loading: false
		};
	},
	components: {
		Modal,
		Spinner
	},
	computed: {
		user() {
			return this.$store.getters.user;
		},
        passcode_uppercase() {
            return this.passcode.toUpperCase();
        }
	},
	methods: {
		async submitPasscode() {
			this.loading = true;
			const response = await this.$http({
				method: "post",
				url:
					"https://us-central1-gleebeam-app.cloudfunctions.net/grant_dashboard_access",
				data: {
					uid: this.user.uid,
					passcode: this.passcode
				}
			});

			this.passcode = "";

			this.loading = false;

			console.log(`Response message: ${response.data.message}`); // eslint-disable-line no-console
		}
	}
};
</script>

<style scoped>
#closeButtonWrapper {
	position: relative;
}

#connectFormWrapper {
	text-align: left;

	padding: 24px;
	/* margin-top: 64px; */
}

#buttonContainer {
	width: 100%;

	display: flex;
	flex-direction: row;
}

#connectFormWrapper input {
	width: 200px;
}
</style>
